import { render, staticRenderFns } from "./WishListModal.vue?vue&type=template&id=aaf306f4&"
import script from "./WishListModal.vue?vue&type=script&lang=js&"
export * from "./WishListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports